export const culture = {
    locale: "sv-SE",
    monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni',
    'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun',
    'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
    dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
    dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
    dateFormat: 'yy-mm-dd',
    datePlaceholder: 'yyyy-mm-dd',
    monthDayFormat: 'mm/dd',
    weekHeader: 'Ve',
    firstDay: 1,
    shortFormat: "M d",
    mediumFormat: "d M, y",
    mediumFullYearFormat: "d M, yy",
    monthShortFormat: "M yy",
    yearFormat: "yy",
    FullFormat: "dd M, yy",
    LongTimeFormat: 'HH:mm:ss',
    shortTimeFormat: 'HH:mm',
    decimalSeparator: ",",
    currencyDecimalSeparator: ',',
    currencyGroupSeparator: ' ',
    moneyWithCurrencyFormat: "{v} {c}",
    from: 'Från',
    by: 'Senast den',
    fromFormat: 'Från {0}',
    byFormat: 'Senast den {0}'
};

export const datepicker = {
    ...culture,
    closeText: 'Stäng',
    prevText: '&laquo;Förra',
    nextText: 'Nästa&raquo;',
    currentText: 'Idag',
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
};
